export const services = [
  {
    name: "Cybersecurity Consultancy",
    keywords: [
      "security", "cyber", "hack", "hacking", "vulnerability", "penetration",
      "wazuh", "siem", "owasp", "kali", "intrusion", "firewall", "breach",
      "threat", "malware", "ransomware", "audit", "compliance", "forensics",
    ],
    description:
      "Penetration testing, SIEM deployment (Wazuh), compliance audits, OWASP application auditing, and incident response planning to protect your digital assets.",
  },
  {
    name: "Network Design & Engineering",
    keywords: [
      "network", "lan", "wan", "router", "switch", "cabling", "ospf", "bgp",
      "vlan", "firewall", "infrastructure", "backbone", "ethernet", "fiber",
    ],
    description:
      "Enterprise-grade LAN/WAN design, routing protocols (OSPF/BGP), VLAN segmentation, structured cabling, and network optimization.",
  },
  {
    name: "ISP Infrastructure Solutions",
    keywords: [
      "isp", "internet provider", "fiber", "gpon", "subscriber", "bandwidth",
      "broadband", "internet service", "last mile", "noc",
    ],
    description:
      "Core/edge network design, GPON fiber deployment, subscriber management, and NOC monitoring dashboards for internet service providers.",
  },
  {
    name: "CCTV Installation & Monitoring",
    keywords: [
      "cctv", "camera", "surveillance", "nvr", "security camera", "ip camera",
      "monitoring", "video", "recording",
    ],
    description:
      "IP camera deployment, NVR configuration, remote mobile viewing, and video analytics for security operations.",
  },
  {
    name: "Web Development",
    keywords: [
      "website", "web app", "web application", "react", "nextjs", "next.js",
      "frontend", "fullstack", "full-stack", "landing page", "ecommerce",
      "e-commerce", "cms", "tailwind", "typescript", "node", "api",
    ],
    description:
      "Custom React/Next.js applications, headless CMS integration, REST/GraphQL APIs, TypeScript, Tailwind CSS, and performant cloud-deployed front-ends.",
  },
  {
    name: "Database Management",
    keywords: [
      "database", "sql", "postgresql", "postgres", "schema", "query",
      "optimize", "migration", "backup", "relational", "normalization",
      "indexing", "stored procedure",
    ],
    description:
      "Designing, building, modifying, and optimizing robust relational database schemas using advanced SQL, PostgreSQL, and secure administration principles.",
  },
  {
    name: "Technical Spatial Planning",
    keywords: [
      "floor plan", "blueprint", "architecture", "container cabin", "spatial",
      "layout design", "structural", "engineering drawing", "partition",
      "iron sheet", "residential plan", "building plan",
    ],
    description:
      "Architectural layouts, custom residential digital floor planning, and engineering structural specifications including container cabin blueprints and iron sheet partitioned designs.",
  },
  {
    name: "IT Consulting & Automation",
    keywords: [
      "consulting", "automation", "python", "ansible", "audit", "it support",
      "devops", "ci/cd", "monitoring", "configuration", "management",
    ],
    description:
      "Network automation (Python/Ansible), configuration management, IT audits, technology roadmap planning, and operational efficiency consulting.",
  },
];

export const faqs = [
  {
    keywords: ["what do you do", "about you", "about carium", "who are you", "what is carium", "tell me about"],
    answer:
      "Carium Tech is a technology agency based in Nairobi, Kenya. We specialize in cybersecurity, network infrastructure, CCTV deployment, ISP solutions, web development, database management, spatial planning, and IT consulting. We partner with businesses across East Africa to build secure, scalable digital systems.",
  },
  {
    keywords: ["how much", "cost", "price", "pricing", "budget", "expensive", "affordable", "quote"],
    answer:
      "Pricing depends on the scope and complexity of your project. We offer free initial consultations to understand your needs. Contact our team at info@cariumtech.com or use the Contact Us page to request a custom quote.",
  },
  {
    keywords: ["where", "location", "based", "office", "address", "nairobi", "kenya"],
    answer:
      "We're based in Nairobi, Kenya. We serve clients across East Africa and offer both virtual and on-site consultations depending on the project.",
  },
  {
    keywords: ["small business", "startup", "sme", "small company"],
    answer:
      "Absolutely. We work with businesses of all sizes — from startups to enterprises. Our solutions are scalable and designed to grow with your business.",
  },
  {
    keywords: ["contact", "reach", "email", "phone", "call", "whatsapp", "talk", "speak"],
    answer:
      "You can reach us via:\n\nEmail: info@cariumtech.com\nPhone/WhatsApp: +254 783 058 354\n\nOr use the Contact Us page on our website. We respond within 24 hours.",
  },
  {
    keywords: ["get started", "start project", "begin", "initiate", "work with you", "hire"],
    answer:
      "To start a project, reach out to us at info@cariumtech.com or click the Contact Us link. We'll schedule a consultation to discuss your requirements, timeline, and budget.",
  },
  {
    keywords: ["react", "next.js", "nextjs", "framework", "technology stack", "tech stack"],
    answer:
      "We build with modern technologies: React, Next.js, TypeScript, Tailwind CSS for frontend; Node.js for backend; PostgreSQL for databases. Our stack is chosen for performance, maintainability, and security.",
  },
  {
    keywords: ["wazuh", "siem", "monitoring", "security monitoring"],
    answer:
      "Yes! We deploy and manage Wazuh SIEM for real-time security monitoring, intrusion detection, and compliance reporting. We also set up Elastic Stack for log analysis and visualization.",
  },
  {
    keywords: ["penetration test", "pen test", "kali", "vulnerability scan", "security test"],
    answer:
      "We offer penetration testing using industry-standard frameworks including Kali Linux tools and OWASP methodologies. Our reports include vulnerability findings, risk ratings, and remediation steps.",
  },
  {
    keywords: ["floor plan", "blueprint", "spatial", "container", "cabin", "architectural"],
    answer:
      "We provide technical spatial planning services including digital floor plans, container cabin blueprints, iron sheet partitioned designs, and structural engineering specifications. Share your requirements and we'll deliver precise plans.",
  },
  {
    keywords: ["database", "sql", "postgresql", "schema design"],
    answer:
      "We design and optimize relational databases using PostgreSQL and advanced SQL. Services include schema design, query optimization, migration planning, performance tuning, and secure administration.",
  },
  {
    keywords: ["cctv", "camera", "surveillance", "security camera"],
    answer:
      "We design and deploy IP camera systems with NVR storage, remote mobile monitoring, and video analytics. Solutions range from small office setups to multi-site enterprise surveillance.",
  },
];

export const contactInfo = {
  email: "info@cariumtech.com",
  phone: "+254 783 058 354",
  whatsapp: "https://wa.me/25483058354",
  location: "Nairobi, Kenya",
};

export const humanHandoffKeywords = [
  "human", "agent", "real person", "speak to someone", "talk to someone",
  "talk to a person", "speak to a human", "need help", "customer service",
  "support", "representative", "live chat", "actual person", "real human",
  "connect me", "transfer", "escalate",
];

export const leadPrompt =
  "I'd be happy to connect you with our team! Please share your **name** and **email** so we can follow up with you.";

export const leadConfirm = (name) =>
  `Thanks ${name}! What would you like to do next?`;

export const whatsappButtonText = "Chat on WhatsApp";
export const emailTranscriptButtonText = "Email Transcript";

export const welcomeMessage =
  "Hello! I'm the Carium Tech assistant. I can help you learn about our services, answer questions, or connect you with our engineering team. How can I help?";

export const fallbackResponse =
  "I'm not sure I understand that. Could you rephrase, or would you like to know about our services? You can also reach our team directly at info@cariumtech.com or chat with us on WhatsApp.";

export const emailSentMessage =
  "Your chat transcript has been sent to our team! We'll reach out to you within 24 hours. Is there anything else I can help with in the meantime?";

export const emailErrorMessage =
  "Sorry, there was an issue sending the email. You can reach us directly at info@cariumtech.com or chat on WhatsApp.";

export const invalidLeadInfo =
  "I couldn't detect a valid name and email. Please try again in this format:\n\n**Your Name, your@email.com**";

export const quoteServicePrompt =
  "Which service do you need a quote for?";

export const quoteCancelled = "No worries! Let me know if you need anything else.";

export const quoteInvalidOption =
  "I didn't quite catch that. Please click one of the options above or type the exact answer.";

export const quoteEmailPrompt = "Please share your email address:";

export const quoteEmailSent =
  "Your quote estimate has been emailed! Our team will follow up with a detailed proposal within 24 hours. Is there anything else I can help with?";

export const quoteEmailNoThanks = "No problem! Feel free to ask if you need anything else.";

export const quickActions = [
  { label: "Our Services", message: "What services do you offer?" },
  { label: "Get a Quote", message: "get a quote" },
  { label: "Talk to Human", message: "I want to talk to a human" },
  { label: "Contact Us", message: "How can I contact you?" },
];
